import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: prefersDark ? 'dark' : 'light'
  }
})
